{
  "version": 1,
  "sources": ["painting-1538", "woodcut-1544", "aar47-spuistraat"],
  "sourceSize": [6692, 4866],
  "notes": "Eight observed roof bodies enclosing the four Raamsteeg gardens: a southern range and return, five wall-side bodies, and a northern cross range. Source pixels identify approximate roof picks, not metre coordinates. Identity and property boundaries are unverified. All metric frontages, depths, street chainages, storeys, roof pitches and axes are estimated fits to retained lanes; slate denotes the dark painted roofs without proving their covering. No inferred subdivision into extra houses.",
  "rows": [
    {
      "id": "raam-south-range",
      "source": "quay-nieuwezijds-achterburgwal-2",
      "side": "right",
      "from": 902,
      "to": 910,
      "depth": 26,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-south-range",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [3095, 1250]
        }
      ]
    },
    {
      "id": "raam-south-return",
      "source": "street-raamsteeg",
      "side": "right",
      "from": 29.86,
      "to": 38.96,
      "depth": 18,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-south-return",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [3135, 1245]
        }
      ],
      "plotAxis": [0.116, 0.993]
    },
    {
      "id": "raam-wall-01",
      "source": "lane-singel-4",
      "side": "right",
      "from": 261,
      "to": 270,
      "depth": 8,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-wall-01",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [3200, 1277]
        }
      ]
    },
    {
      "id": "raam-wall-02",
      "source": "lane-singel-4",
      "side": "right",
      "from": 276,
      "to": 284,
      "depth": 8,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-wall-02",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "slate",
          "gable": "plain",
          "paintedPixel": [3238, 1293]
        }
      ]
    },
    {
      "id": "raam-wall-03",
      "source": "lane-singel-4",
      "side": "right",
      "from": 285,
      "to": 294,
      "depth": 8,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-wall-03",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [3270, 1312]
        }
      ]
    },
    {
      "id": "raam-wall-04",
      "source": "lane-singel-4",
      "side": "right",
      "from": 295,
      "to": 304,
      "depth": 8,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-wall-04",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "gable": "stepped",
          "paintedPixel": [3312, 1307]
        }
      ]
    },
    {
      "id": "raam-wall-05",
      "source": "lane-singel-4",
      "side": "right",
      "from": 304,
      "to": 312,
      "depth": 8,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-wall-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "gable": "stepped",
          "paintedPixel": [3343, 1325]
        }
      ]
    },
    {
      "id": "raam-north-range",
      "source": "quay-nieuwezijds-achterburgwal-2",
      "side": "right",
      "from": 827.5,
      "to": 835.5,
      "depth": 26,
      "shear": 0,
      "evidence": "painted",
      "houses": [
        {
          "id": "raam-north-range",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain",
          "paintedPixel": [3340, 1370]
        }
      ],
      "plotAxis": [-0.925, -0.38]
    }
  ]
}
